import React, { useState } from "react";
import {
    DatePicker,
    Form,
    Modal,
    Popover,
    Select,
    message,
    Input,
    Pagination,
  } from "antd";

import { useSelector, useDispatch } from "react-redux";
import { Radio } from "antd";
import { useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import { ADMIN_USER, USER_DATA } from "../../../constants/const";
import { getFromLocalStorage } from "../../../Helpers/localStorageHelper";
import moment from "moment";
import { createTimeSlots } from "../../../Helpers/DateHelpers";
import { createDropdownValues } from "../../../Helpers/helperFunctions";
import Assets from "../../Layout/Assets";
import {
  FETCH_ADMIN_DASHBOARD_REPORT,
  fetch_doctors_list,
  acceptrejectrequest,
  FETCH_REQUEST_DASHBOARD_REPORT
} from "../../../actions/ClinicAdminAction";
import { AssetStore } from "../../../assets/AssetsStore";
import styles from "../../InterbranchAdminComponents/RequestedAppointments/index.module.scss";
import { color } from "@mui/system";
const RadioGroup = Radio.Group;

function RejectModal({ open, togggle, appointmentData, setProcessdone }) {
    const options = [
      {
        label: "Multiple appointment requests",
        value: "Multiple appointment requests",
      },
      {
        label: "Referred to another Doctor/Specialist",
        value: "Referred to another Doctor/Specialist",
      },
      {
        label: "Met the doctor/Specialist in person",
        value: "Met the doctor/Specialist in person",
      },
      { label: "No consultation required", value: "No consultation required" },
      { label: "Doctor is not available", value: "Doctor is not available" },
      { label: "Doctor is on a vacation", value: "Doctor is on a vacation" },
    ];
  
    const [value, setValue] = useState();
    const [error, setError] = useState();
    const dispatch = useDispatch();
  
    console.log("appointmentData",appointmentData)
    function onChange(e) {
      console.log("onChange", e.target.value);
      setValue(e.target.value);
      if (!e.target.value) {
        setError(true);
      } else {
        setError(false);
      }
    }
  
    function handleRejectSubmit() {
      console.log("handleRejectSubmit", value);
      if (!value) {
        setError(true);
      } else {
        let param = {
          process: "cancel",
          appointmentId: appointmentData.appointmentRequestId,
          // "UserId":userId,
          reason: value,
        };
        console.log("param", param);
  
        dispatch(acceptrejectrequest(param)).then((res) => {
          console.log("res", res);
          togggle(false);
          setProcessdone(true);
        });
        message.success(`Appointment rejected`);
        setError(false);
        togggle(false);
        setValue("");
      }
    }
  
    return (
      <Modal
        className={`${styles.customModal} ${styles.customModalReject}`}
        footer={false}
        closeIcon={<></>}
        header={null}
        open={open}
      >
        <div className={styles.modalBody}>
          <h5>Select reason for rejection !</h5>
  
          <RadioGroup options={options} onChange={onChange} value={value} />
          {error ? (
            <span className={styles.validationError}>
              *Please select reason !!!
            </span>
          ) : (
            ""
          )}
        </div>
  
        <div className={styles.modalFooter}>
          <button
            className={styles.closeModalBtn}
            onClick={() => {
              togggle(false);
              setValue("");
            }}
          >
            Close
          </button>
          <button className={styles.rejectModalBtn} onClick={handleRejectSubmit}>
            Reject
          </button>
        </div>
      </Modal>
    );
  };

  export default RejectModal;